import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=52a2b96b&scoped=true&"
var script = {}
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=52a2b96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2b96b",
  null
  
)

export default component.exports